/* Nokka — progressive AJAX add-to-cart.
   Any <form class="nk-add-form"> posts to the cart without a page reload,
   updates the nav cart count, and confirms on the button. Falls back to a
   normal POST if fetch fails or JS is off. */
(function () {
  if (window.__nkCartInit) return;
  window.__nkCartInit = true;

  function setCount(n) {
    document.querySelectorAll('[data-nk-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
  }

  function showCartLink(form) {
    var panel = form.querySelector('[data-nk-cart-next-panel]');
    if (!panel) {
      panel = document.createElement('div');
      panel.setAttribute('data-nk-cart-next-panel', 'true');
      panel.className = 'nk-cart-next-panel';

      var message = document.createElement('div');
      message.className = 'nk-cart-next-message';
      message.textContent = 'Added to cart.';

      var note = document.createElement('div');
      note.className = 'nk-cart-next-note';
      note.textContent = 'Checkout opens shipping and tax review before payment.';

      var link = document.createElement('a');
      link.setAttribute('data-nk-cart-next', 'true');
      link.className = 'nk-cart-next';
      link.href = '/cart';
      link.textContent = 'View cart ->';

      var checkout = document.createElement('a');
      checkout.setAttribute('data-nk-cart-checkout-next', 'true');
      checkout.className = 'nk-cart-next nk-cart-next--checkout';
      checkout.href = '/checkout';
      checkout.textContent = 'Checkout ->';

      var actions = document.createElement('div');
      actions.className = 'nk-cart-next-actions';
      actions.appendChild(link);
      actions.appendChild(checkout);

      panel.appendChild(message);
      panel.appendChild(note);
      panel.appendChild(actions);
      form.appendChild(panel);
    }
    panel.hidden = false;
  }

  function isProductPage() {
    return window.location && /^\/products\//.test(window.location.pathname || '');
  }

  function suppressProductChecklistPrompt() {
    if (!isProductPage()) return;
    if (document.body && document.body.classList) {
      document.body.classList.add('nk-suppress-marketing-popups');
    }
    document.querySelectorAll('[data-nk-check-prompt], .nk-check-prompt').forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function installProductChecklistPromptSuppression() {
    if (!isProductPage()) return;
    suppressProductChecklistPrompt();
    window.setTimeout(suppressProductChecklistPrompt, 4700);
    window.setTimeout(suppressProductChecklistPrompt, 7000);
  }

  function cleanText(node) {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function fieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value : '';
  }

  function nearest(form, selector) {
    return form.closest ? form.closest(selector) : null;
  }

  function quickAddContext(form) {
    if (nearest(form, '.pcard')) return 'collection_card';
    if (nearest(form, '.nk-card')) return 'product_grid';
    if (nearest(form, '.nk-kit')) return 'kit_band';
    return 'quick_add';
  }

  function quickAddProductTitle(form) {
    var named = nearest(form, '[data-name]');
    if (named && named.getAttribute('data-name')) return named.getAttribute('data-name');
    var container = nearest(form, '.pcard, .nk-card, .nk-kit') || form;
    return cleanText(container.querySelector('.pname, .name, h2, h3'));
  }

  function trackQuickAdd(form, btn) {
    if (form.getAttribute('id') === 'nk-product-form' || nearest(form, '.nk-fit')) return;
    var productTitle = quickAddProductTitle(form);
    var payload = {
      event_category: 'quick_add',
      event_label: productTitle,
      product_title: productTitle,
      variant_id: fieldValue(form, 'id'),
      quantity: fieldValue(form, 'quantity') || '1',
      submit_source: quickAddContext(form),
      button_text: cleanText(btn),
      page_path: window.location ? window.location.pathname : ''
    };
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'nokka_quick_add_submit' }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'nokka_quick_add_submit', Object.assign({}, payload, { send_to: 'G-KT09F79JPL' }));
    }
  }

  installProductChecklistPromptSuppression();

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form.nk-add-form') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    trackQuickAdd(form, btn);
    if (btn) { btn.disabled = true; }

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        showCartLink(form);
        if (btn) {
          btn.innerHTML = 'Added ✓';
          setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1600);
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (cart) {
            setCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('nk:cart:added', { detail: cart }));
          })
          .catch(function () {});
      })
      .catch(function () { form.submit(); });
  });
})();
